/* tslint:disable */
/* eslint-disable */
export enum LotState {
  Available = 'available',
  Unsold = 'unsold',
  Sold = 'sold',
  Withdrawn = 'withdrawn'
}
